import React from 'react'
import { Link } from 'react-router-dom'
import makeUrlFriendly from './../../lib/makeUrlFriendly'
import injectStyles from 'react-jss'

const styles = {
  select: {
    backgroundColor: '#f2f3f4',
    height: 68,
    color: '#4f4f4f',
    fontSize: 16,
    padding: '26px 39px',
    boxSizing: 'border-box',
  },
}

const RepositorySelect = ({ name, classes }) =>
  <Link
    to={'/repo/' + makeUrlFriendly(name)}
  >
    <div className={classes.select}>
      <span>{name}</span>
    </div>
  </Link>

export default injectStyles(styles)(RepositorySelect)



// WEBPACK FOOTER //
// ./src/modules/RepositorySelect/RepositorySelect.js